import { useModulePageDetails } from "modules/brands/pages/ModulesContainer/components/PageModules/components/ModuleDetailsDrawer/context";
import { useGeneralData } from "modules/brands/pages/ModulesContainer/components/PageModules/components/ModuleDetailsDrawer/stores/useGeneralData";
import { type FC } from "react";
import CardBlockForm from "./components/CardBlockForm";

const ThreeCardBlocksConfig: FC = () => {
  const { threeCardsLoadingQueries } = useModulePageDetails();
  const { contentBlocks } = useGeneralData();

  if (!contentBlocks || !contentBlocks.length) {
    return null;
  }

  return (
    <>
      {contentBlocks?.map((item, index) => (
        <CardBlockForm
          key={index}
          item={item}
          index={index}
          isLoadingFile={threeCardsLoadingQueries[index]}
        />
      ))}
    </>
  );
};

export default ThreeCardBlocksConfig;
